import { FormikProps } from "formik";
import React from "react";
import Button from "../Button";
import { ChangePasswordType } from "../../pages/Settings";
import Input from "../Input";

interface PropTypes {
  formik: FormikProps<ChangePasswordType>;
}

const ChangePasswordForm = ({ formik }: PropTypes) => {
  return (
    <form onSubmit={formik.handleSubmit}>
      <h1 className="text-lg font-semibold mb-2 mt-5">Change password</h1>
      <div className="lg:grid lg:grid-cols-3 lg:items-center lg:gap-10 mb-4">
        <Input
          value={formik.values.oldPassword}
          label='Old password:'
          name="oldPassword"
          onChange={formik.handleChange}
          className="w-30% h-14 px-4 text-sm focus:outline-none"
          placeholder="Enter old password"
          labelClassName='text-[16px] lg:text-[16px]'
        />
        <Input
          value={formik.values.newPassword}
          label='New password:'
          name="newPassword"
          onChange={formik.handleChange}
          className="w-30% h-14   px-4 text-sm focus:outline-none"
          placeholder="New password"
          labelClassName='text-[16px] lg:text-[16px]'
        />
        <Input
          value={formik.values.confirmNewPassword}
          label='Confirm new password:'
          name="confirmNewPassword"
          onChange={formik.handleChange}
          className="w-30% h-14   px-4 text-sm focus:outline-none"
          placeholder="Confirm new password"
          labelClassName='text-[16px] lg:text-[16px]'
        />

      </div>
      {Object.keys(formik.errors).length > 0 && (
        <div className="text-red-500 my-4">
          <p>{Object.values(formik.errors)[0]}</p>
        </div>
      )}
      <div className='w-full flex justify-center lg:justify-start'>
        <Button className="w-full md:w-32 min-h-0 h-10 md:h-10" isLoading={formik.isSubmitting}>
          Save
        </Button>
      </div>
    </form>
  );
};

export default ChangePasswordForm;
